import React, { Component } from "react";
import Fade from "react-reveal";

class About extends Component {
  render() {
    if (!this.props.data) return null;

    return (
      <section id="about">
        <Fade duration={1000}>
          <div className="row">
            <div className="six columns">
              <img
                alt="" 
                src="images/arquitecture.png"
              />
            </div>
            <div className="six columns">
              <h2>General system</h2>
              <p>
                A matrix of reed switches is used to detect the magnets inside the pieces.
                The information is picked up by the microprocessor, ATMEGA, where a custom
                smart chess library written in C remembers the positions of pieces in lasts plays and 
                calculates the move played, sending all the information to the actuators 
                if it's an illegal move, or by serial to a computer (used only to represent the match).
              </p>
            </div>
          </div>
          <div className="row">
            <h2>Detection of the pieces</h2>
            <p>
              All pieces have a small magnet inside.
              When a piece is in a square, the correspondent reed sensor is closed. All The reed sensors are connected by columns and rows.
              The microprocessor sends 5V through successive columns and reads the output from the rows, getting a "binary map" representing the state of the game.
              As all chess games start from the same position, with this information the ATMEGA can remember the position of the pieces and follow the play.
              To fight the Ghost Key effect (get more information <a href="docs/ghostKey.pdf">here</a>) a diode has been incorporated at the end of each switch (See <a href="#resume">Hardware & Software section</a>)
            </p>
          </div>
          <div className="row">
            <h2>User interface</h2>
            <p>
              A basic python console program was developed to show the possibilities of the system. A "DEBUG mode" was also developed to check the correct working of the reed switches.
              Feedback of the system can also be obtained with LEDs, for example, the red LED shows when an illegal move is played. 
            </p>
          </div>
        </Fade>
      </section>
    );
  }
}

export default About;
